import React from "react";
import styled from "styled-components";
import { rem } from "polished";
import { ICONS } from "../../../icons/Icons";
import Icon from "../../../icons/Icon";
import colors from "../../../utils/colors";
import { Localize } from "../../../locale/localization";

const Wrapper = styled.div`
  text-align: center;
  margin: ${rem("40px")} auto 0 auto;
  color: ${colors.BRAND_RED};
  cursor: pointer;

  p {
    font-size: ${rem("16px")};
    font-weight: 600;
    display: inline-block;
    margin-bottom: 0;
  }

  svg {
    vertical-align: top;
    padding: 0 0.75rem;
    margin-left: -1.75rem;
  }
`;

const LoadMore = props => {
  return (
    <Wrapper {...props}>
      <Icon
        icon={ICONS.PLUS}
        width={rem("20px")}
        height={rem("20px")}
        stroke={colors.BRAND_RED}
      />
      <p>{Localize("action.show.more")}</p>
    </Wrapper>
  );
};

export default LoadMore;



// WEBPACK FOOTER //
// ./src/modules/pages/components/LoadMore.js